<script>
import ModalSelectCareerComponent from '../features/ModalSelectCareerComponent';

export default {
  name: 'ModalSelectCareerView',
  extends: ModalSelectCareerComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      class="select-careers-modal"
      :before-close="onCancel"
      :close-on-click-modal="false"
      append-to-body
    >
      <template #header>
        <div class="student_modal_header">
          <div class="student_modal_header_icon">
            <i class="fas fa-graduation-cap" />
          </div>
          <div class="student_modal_header_info">
            <h3 class="student_modal_title">
              Seleccionar Carreras Universitarias
            </h3>
            <p class="student_modal_subtitle">
              Elige tu universidad y las áreas de conocimiento de tu interés para filtrar y seleccionar tus opciones
            </p>
          </div>
        </div>
      </template>

      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <div class="student_form_section">
          <div class="student_section_header">
            <h4 class="student_section_title">
              <i class="fas fa-university" /> Universidad y Áreas
            </h4>
          </div>

          <el-row
            class="row-bg"
            :gutter="16"
          >
            <el-col :span="24">
              <el-form-item
                label="Universidad"
                prop="university"
              >
                <el-select
                  v-model="formData.university"
                  clearable
                  filterable
                  placeholder="Seleccionar universidad de interés"
                  value-key="id"
                  style="width: 100%"
                  @change="onSelectUniversity"
                >
                  <el-option
                    v-for="item in universities"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row
            v-if="knowledgeAreas && knowledgeAreas.length > 0"
            class="row-bg mt-2"
            :gutter="16"
          >
            <el-col :span="24">
              <div class="mb-2">
                <span style="font-size: 0.82rem; font-weight: 700; color: #1e293b;">Áreas de Conocimiento</span>
              </div>
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
              >
                Marcar todas
              </el-checkbox>
              <div style="margin: 10px 0" />
              <el-checkbox-group
                v-model="checkedKnowledgeAreas"
                @change="handleCheckedKnowledgeAreasChange"
              >
                <el-checkbox
                  v-for="knowledgeArea in knowledgeAreas"
                  :key="knowledgeArea.id"
                  :value="knowledgeArea.id"
                >
                  {{ knowledgeArea.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </div>

        <div class="student_form_section">
          <div class="student_section_header">
            <h4 class="student_section_title">
              <i class="fas fa-list-check" /> Carreras Disponibles
            </h4>
          </div>

          <div class="student_table_wrap">
            <el-table
              ref="multipleTable"
              :data="collection"
              style="width: 100%"
              max-height="280"
              class="student_careers_table"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="50"
                align="center"
              />
              <el-table-column
                prop="name"
                label="Carrera"
                min-width="200"
              />
              <el-table-column
                label="Área"
                min-width="160"
              >
                <template #default="scope">
                  <span class="badge_knowledge_area">
                    {{ scope.row.knowledgeArea ? scope.row.knowledgeArea.name : '-' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="Universidad"
                min-width="160"
              >
                <template #default="scope">
                  <span>{{ scope.row.university ? scope.row.university.name : '-' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>

      <template #footer>
        <div class="student_modal_footer">
          <el-button
            class="btn_add_highschool"
            @click="onCancel"
          >
            Cancelar
          </el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn_submit_student_info"
            @click="onSubmitForm('formData')"
          >
            <i class="fas fa-check mr-1" /> Aceptar y Agregar
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
